import React, { forwardRef } from 'react';
import { Button } from 'semantic-ui-react';

const ChatInput = forwardRef(({
  input,
  onInputChange,
  onKeyDown,
  onSubmit,
  isLoading,
  allow_chat,
  rateLimitCountdown,
  placeholder,
  chatNotAllowed,
  isRTL
}, ref) => {
  return (
    <div style={{
      backgroundColor: '#f5f5f5',
      padding: '8px',
      borderTop: '1px solid #e0e0e0',
      flex: '0 0 auto'
    }}>
      <form onSubmit={onSubmit} style={{
        display: 'flex',
        backgroundColor: '#fff',
        borderRadius: '4px',
        border: '1px solid rgba(34,36,38,.15)'
      }}>
        <input
          ref={ref}
          type="text"
          value={input}
          onChange={onInputChange}
          onKeyDown={onKeyDown}
          className="editor"
          placeholder={allow_chat ? placeholder : chatNotAllowed}
          disabled={!allow_chat || isLoading || rateLimitCountdown > 0}
          style={{
            flex: 1,
            padding: '0.5rem',
            marginRight: '0.5rem',
            border: '1px solid #ddd',
            borderRadius: '4px',
            direction: isRTL ? 'rtl' : 'ltr'
          }}
        />
        <Button
          type="submit"
          icon="send"
          disabled={!input.trim() || isLoading}
          loading={isLoading}
          color="green"
          style={{
            margin: 0,
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            borderTopRightRadius: '4px',
            borderBottomRightRadius: '4px'
          }}
        />
      </form>
    </div>
  );
});

export default ChatInput;